// Auto-generated normalizer for table: ExamenPreguntaOpcionMultiple_Opciones
export function examenPreguntaOpcionMultipleOpcionesNormalize(row) {
  return {
    idExamenOpcion: row.idExamenOpcion ?? row.IdExamenOpcion ?? row['IdExamenOpcion'] ?? 0,
    idExamenRespuestaOpcionMultiple: row.idExamenRespuestaOpcionMultiple ?? row.IdExamenRespuestaOpcionMultiple ?? row['IdExamenRespuestaOpcionMultiple'] ?? 0,
    texto: row.texto ?? row.Texto ?? row['Texto'] ?? '',
    esCorrecta: row.esCorrecta ?? row.EsCorrecta ?? row['EsCorrecta'] ?? false,
    orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
